export default class AzureSearchGui {
  constructor(settings) {
    this.showFacets = true;
    this.showSearchBar = false;
    this.executeSearchOnLoad = true;
    this.page = 1;
    if (settings) {
      if (settings.showFacets !== undefined && settings.showFacets !== null)
        { this.showFacets = settings.showFacets; };
      if (
        settings.showSearchBar !== undefined &&
        settings.showSearchBar !== null
      )
        { this.showSearchBar = settings.showSearchBar; };
      if (
        settings.executeSearchOnLoad !== undefined &&
        settings.executeSearchOnLoad !== null
      )
        { this.executeSearchOnLoad = settings.executeSearchOnLoad; };
      if (settings.Page !== undefined && settings.Page !== null)
        { this.Page = settings.Page; };
    }
  }
}
